import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router'

declare var $ : any;

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})

export class ForgotPasswordComponent implements OnInit {

  isError = false;
  submitSuccess = false;

  constructor(private authService : AuthService, private router : Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
   }

  ngOnInit() {
    this.isError = false;
    this.submitSuccess = false;
  }

  OnSubmit(fullname, phone, email){
    this.submitSuccess = false;
    this.isError = false;
    this.authService.forgotPassword(fullname, phone, email)
      .subscribe(
        (data:any) => {
          this.submitSuccess = true;
        },
        (err:HttpErrorResponse) => {
          console.log(err);
          this.isError = true;
        }
      );
  }
}
